import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Video, Upload, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { WaiverForm } from "../components/WaiverForm";

export default function VideoNotePage() {
  const { token } = useParams();
  const [r, setR] = useState(null);
  const [err, setErr] = useState("");
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [waiver, setWaiver] = useState("");
  const rec = useRef(); const pick = useRef();
  useEffect(() => { api.get(`/public/video-notes/${token}`).then((x) => { setR(x.data); setDone(x.data.done); setWaiver(localStorage.getItem(`lif_waiver_${x.data.slug}`) || ""); }).catch((e) => setErr(formatApiError(e))); }, [token]);
  const choose = (e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) setFile(f); };
  async function send() {
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file); fd.append("waiver_token", waiver);
    try { await api.post(`/public/video-notes/${token}`, fd); setDone(true); toast.success("Your video note is on their wedding party page!"); }
    catch (e) { if (e?.response?.status === 403) { localStorage.removeItem(`lif_waiver_${r.slug}`); setWaiver(""); } toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  }
  if (err) return <div className="min-h-screen flex items-center justify-center p-8 text-center font-serif text-2xl" data-testid="vn-page-error">{err}</div>;
  if (!r) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-[var(--gold)]" /></div>;
  return (
    <div className="min-h-screen bg-[var(--bg-warm)] py-12 px-5" data-testid="vn-page">
      <div className="max-w-md mx-auto bg-white rounded-3xl p-7 border border-[var(--line)] space-y-5">
        <p className="font-script text-4xl text-[var(--gold)]">{r.couple_names}</p>
        <h1 className="font-serif text-3xl font-light">Hi {r.name.split(" ")[0]}, would you record a video note?</h1>
        <p className="text-[var(--muted)] text-sm">{r.message || "A short hello, a story or your best marriage advice. It will appear on our wedding party page."}</p>
        {done ? (
          <div className="text-center py-6 space-y-3" data-testid="vn-done">
            <Check className="w-10 h-10 mx-auto text-[var(--gold)]" />
            <p className="font-serif text-2xl">Thank you!</p>
            <Link to={`/site/${r.slug}`} className="btn-gold inline-block" data-testid="vn-view-site">See the wedding site</Link>
          </div>
        ) : !waiver ? (
          <WaiverForm drawn withEmail cta="Sign & record" submit={async (b) => (await api.post(`/public/weddings/${r.slug}/waiver`, b)).data}
            onSigned={(w) => { localStorage.setItem(`lif_waiver_${r.slug}`, w.token); setWaiver(w.token); }} />
        ) : (
          <div className="space-y-3">
            {file && <video src={URL.createObjectURL(file)} controls playsInline className="w-full rounded-2xl bg-black max-h-[60vh]" data-testid="vn-preview" />}
            <div className="grid grid-cols-2 gap-3">
              <button onClick={() => rec.current?.click()} className="btn-gold !py-3 flex items-center justify-center gap-2" data-testid="vn-record-btn"><Video className="w-4 h-4" /> {file ? "Re-record" : "Record"}</button>
              <button onClick={() => pick.current?.click()} className="btn-outline-gold !py-3 flex items-center justify-center gap-2" data-testid="vn-pick-btn"><Upload className="w-4 h-4" /> Choose video</button>
            </div>
            {file && <button onClick={send} disabled={busy} className="btn-gold w-full !py-3" data-testid="vn-send-btn">{busy ? "Sending…" : "Send my video note"}</button>}
            <input ref={rec} type="file" accept="video/*" capture="user" className="hidden" onChange={choose} data-testid="vn-record-input" />
            <input ref={pick} type="file" accept="video/*" className="hidden" onChange={choose} data-testid="vn-file-input" />
          </div>
        )}
      </div>
    </div>
  );
}
